import React from 'react';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { Box, Typography, styled } from '@bluedolphin/ui';
import { useTranslation } from 'react-i18next';

const StyledNavLink = styled(NavLink)({
    display: 'block',
    textDecoration: 'none',
    padding: '4px 16px',
    '&.active': {
        backgroundColor: 'rgba(0, 71, 187, 0.08)',
    },
    '&:hover': {
        backgroundColor: 'rgba(0, 71, 187, 0.03)',
    },
});

const SideNavSubHeader = styled(Typography)({
    color: 'rgba(29, 31, 36, .6)',
    fontSize: '14px',
    lineHeight: '48px',
    letterSpacing: '0.1px',
    paddingLeft: '16px',
    paddingRight: '16px',
});
const SideNavSubTitle = styled(Typography)({
    color: '#1D1F24',
    fontSize: '14px',
    lineHeight: '20.02px',
    letterSpacing: '0.17px',
    fontWeight: 400,
});
const SideNavBar = () => {
    const { t } = useTranslation();
    let match = useRouteMatch('/:tenantId');

    return (
        <Box
            className="sidenav"
            sx={{
                width: '268px',
                borderRight: '1px solid rgba(29, 31, 36, .23)',
                bgcolor: '#ffffff',
            }}
        >
            <Box className="sidenav__catergory" sx={{ mb: 5 }}>
                <Box id="sidenav_category_header">
                    <SideNavSubHeader>{t('profile.settings')}</SideNavSubHeader>
                </Box>
                <Box id="sidenav_catergory_item">
                    <StyledNavLink
                        to={`${match?.url}/settings/profile`}
                        activeClassName="active"
                    >
                        <SideNavSubTitle variant="body2" sx={{ pt: 1, pb: 1 }}>
                            {t('profile.nav.profileTab')}
                        </SideNavSubTitle>
                    </StyledNavLink>
                </Box>
            </Box>
            {/* <Box className="sidenav__catergory" sx={{ mb: 5 }}>
                <Box id="sidenav_category_header">
                    <SideNavSubHeader>System</SideNavSubHeader>
                </Box>
                <Box id="sidenav_catergory_item">
                    <StyledNavLink
                        to={`${match?.url}/setting/general`}
                        activeClassName="active"
                    >
                        <SideNavSubTitle variant="body2" sx={{ pt: 1, pb: 1 }}>
                            general
                        </SideNavSubTitle>
                    </StyledNavLink>
                </Box>
            </Box> */}
        </Box>
    );
};

export default SideNavBar;
